export default __webpack_public_path__ + "static/media/team-activators.86b1c50b.svg";